import { Button, ButtonProps } from "./Button"

export function ShareButton(props: ButtonProps & { shareTitle?: string; shareUrl?: string }) {
  const { shareTitle, shareUrl, ...buttonProps } = props
  const onClick = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (env.admin) return
    if (props.onClick) {
      props.onClick(e)
    }
    e.preventDefault()
    // share button logic
    if (navigator.share) {
      navigator
        .share({
          title: props.shareTitle || "Share",
          url: props.shareUrl || window.location.href,
        })
        .catch((error) => console.error("Error sharing:", error))
    }
  }

  return (
    <Button {...buttonProps} onClick={onClick}>
      {props.children}
    </Button>
  )
}
